import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";

// Source: https://fonts.google.com/icons?icon.query=menu&selected=Material+Symbols+Rounded:menu:FILL@0;wght@300;GRAD@0;opsz@24&icon.size=24&icon.color=%23e3e3e3&icon.style=Rounded
export const MenuIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Menu Icon</title>;
    t1 = <path d="M4.75001 17.0345C4.56584 17.0345 4.41151 16.9727 4.28701 16.8492C4.16234 16.7255 4.10001 16.5723 4.10001 16.3895C4.10001 16.2068 4.16234 16.052 4.28701 15.925C4.41151 15.7981 4.56584 15.7347 4.75001 15.7347H19.25C19.4342 15.7347 19.5885 15.7965 19.713 15.92C19.8377 16.0436 19.9 16.1969 19.9 16.3797C19.9 16.5624 19.8377 16.7172 19.713 16.8442C19.5885 16.971 19.4342 17.0345 19.25 17.0345H4.75001ZM4.75001 12.65C4.56584 12.65 4.41151 12.5881 4.28701 12.4645C4.16234 12.3408 4.10001 12.1876 4.10001 12.005C4.10001 11.8221 4.16234 11.6673 4.28701 11.5405C4.41151 11.4135 4.56584 11.35 4.75001 11.35H19.25C19.4342 11.35 19.5885 11.4118 19.713 11.5355C19.8377 11.6591 19.9 11.8123 19.9 11.995C19.9 12.1778 19.8377 12.3326 19.713 12.4595C19.5885 12.5865 19.4342 12.65 19.25 12.65H4.75001ZM4.75001 8.2652C4.56584 8.2652 4.41151 8.20345 4.28701 8.07995C4.16234 7.95629 4.10001 7.80304 4.10001 7.6202C4.10001 7.43754 4.16234 7.2827 4.28701 7.1557C4.41151 7.02887 4.56584 6.96545 4.75001 6.96545H19.25C19.4342 6.96545 19.5885 7.0272 19.713 7.1507C19.8377 7.27437 19.9 7.42762 19.9 7.61045C19.9 7.79312 19.8377 7.94795 19.713 8.07495C19.5885 8.20179 19.4342 8.2652 19.25 8.2652H4.75001Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};